import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import DOMPurify from 'dompurify';
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from '../../assets/logos/icare_acrologo.png';
import { sendReactGAPageView } from "../../consts/helpers";
import useAuthUser from "../../hooks/useAuthUser";

export default function FeedbackChatPage() {
	const { pathname } = useLocation();
	useEffect(() => {
        sendReactGAPageView(pathname, 'Chat', false);
    }, [pathname])

    var { userid }  = useAuthUser();
    const navigate = useNavigate();
    
    // Inputs
    const [feedbackInputs, setFInputs] = useState({});

    // Flags
    const [isReadySubmit, setReady] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);
    const [isSubmitSuccess, setSuccess] = useState(false);

    const handleBackButtonClick = () => {
        navigate('/feedback');
    }
    
    // const handleSubmit = () => {
    //     setSubmitting(true);
    //     const body = {
    //         uid: userid,
    //         feedbackInputs: feedbackInputs,
    //     }

    //     const url = process.env.REACT_APP_FEEDBACK_LAMBDA;
    //     fetch(url, {
    //         method: 'POST',
    //         body: JSON.stringify(body),
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //         },
    //     }).then(response => {
    //         return response.json();
    //     }).then(data => {
    //         // Set display flags
    //         setSubmitting(false);
    //         setSuccess(data?.isSuccess);
    //     }).catch(error => {
    //         console.error('There has been a problem with your fetch operation:', error);
    //         return {};
    //     });
    // }

    const sanitizedText = (text) => ({
        __html: DOMPurify.sanitize(text)
    })

    return (
        <>
            <Stack direction={'row'} spacing={1} sx={{ pt: '32px' }}>
                <IconButton onClick={handleBackButtonClick}>
                    <ArrowBack />
                </IconButton>
                <Box>
                    <img src={logo} alt='icare app logo' style={{ maxWidth: 100 }}/>
                </Box>
            </Stack>

            <Box sx={{ flex: 'auto', py: 2 }} className='spread-y'>
                <Stack spacing={2}>
                {/* <Typography variant="h6">Chat with us</Typography> */}

                <Typography variant="body2">This page is currently under construction.<br/> Thank you for your understanding!</Typography>

                </Stack>
            </Box>
        </>
    )
}